
/*
|--------------------------------------------------------------------------
| Custom Javascript code
|--------------------------------------------------------------------------
|
| Now that you configured your website, you can write additional Javascript
| code inside the following function. You might want to add more plugins and
| initialize them in this file.
|
*/

$(function() {



});



//////////////////
// WEBPACK FOOTER
// ./src/assets/js/src/script.js
// module id = 82
// module chunks = 0